import { Flex } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const InfoContainer = styled(Flex)`
  width: 100%;
  order: 1;

  > :last-child {
    margin-top: 1.5rem;
  }

  ${mediaQuery('md')} {
    order: unset;

    > :first-child {
      margin-bottom: 2rem;
    }

    > :last-child {
      margin-top: 3rem;
    }
  }
`;
